export const firstForm = {
  pt: {
    tituloform1: "Verificação de Responsabilidade da Companhia Aérea",
    pularEtapa: "Sou Conciliador e quero pular esta etapa",
    bloco1: "Bloco 1: Horário de Comparecimento ao Embarque",
    tipoVoo: "Tipo de voo:",
    selecione: "Selecione",
    internacional: "Internacional",
    nacional: "Nacional",
    horarioEmbarque: "Horário marcado para embarque:",
    horarioChegada: "Horário de chegada ao aeroporto:",
    conexao: "O voo envolvia conexão comprada separadamente?",
    sim: "Sim",
    nao: "Não",

    bloco2: "Bloco 2: Atraso ou Cancelamento de Voo",
    vooAtrasado: "O voo teve atraso superior a 4 horas?",
    assistencia: "Recebeu assistência (alimentação, hospedagem)?",

    bloco3: "Bloco 3: Condições Climáticas",
    clima: "As condições climáticas afetaram o aeroporto?",
    anac: "Verifique as condições climáticas no site da ANAC:",
    cliqueAqui: "Clique aqui",

    bloco4: "Bloco 4: Bagagem",
    bagagem: "Sua bagagem apresentou algum problema?",
    nenhum: "Não houve problema com a bagagem",
    extravio: "Foi extraviada",
    dano: "Foi danificada",
    furto: "Foi furtada",

    verificar: "Verificar Responsabilidade",
    proximaPagina: "Ir para a próxima página",

    // Resultados
    resultadoNaoIndicios: "Não há indícios de responsabilidade direta da companhia aérea.",
    excludente: "⚠️ Há elementos que indicam excludente(s) de responsabilidade da companhia aérea.",
    excludenteEResponsavel: "⚠️ Há elementos que indicam excludente(s), mas também indícios de responsabilidade.",
    podeResponsabilizar: "✅ A companhia aérea pode ser responsabilizada conforme os fatos relatados.",
    passageiroAntecedencia: "Passageiro não chegou com antecedência mínima exigida. Companhia pode não ser responsabilizada.",
    conexaoExcludente: "Excludente: conexão comprada separadamente. Responsabilidade é do consumidor.",
    atraso: "Voo atrasado por mais de 4 horas. Companhia deve ter prestado assistência.",
    atrasoSemAssistencia: "Companhia pode ser responsabilizada por não prestar assistência durante o atraso.",
    climaExcludente: "Excludente: condições climáticas adversas podem isentar a companhia aérea de responsabilidade.",
    bagagemExtravio: "Problema relatado com a bagagem: extravio.",
    bagagemDano: "Problema relatado com a bagagem: dano.",
    bagagemFurto: "Problema relatado com a bagagem: furto.",
    bagagemFurtoExcludente: "Excludente: itens de valor devem ser levados na bagagem de mão e declarados.",
  },
  en: {
    tituloform1: "Assessment of Airline Responsibility",
    pularEtapa: "I am a Conciliator and want to skip this step",
    bloco1: "Block 1: Boarding Check-in Time",
    tipoVoo: "Flight type:",
    selecione: "Select",
    internacional: "International",
    nacional: "Domestic",
    horarioEmbarque: "Scheduled Boarding Time:",
    horarioChegada: "Boarding Check-in Time:",
    conexao: "Did the flight involve a separately purchased connection?",
    sim: "Yes",
    nao: "No",

    bloco2: "Block 2: Flight Delay or Cancellation",
    vooAtrasado: "Was the flight delayed more than 4 hours?",
    assistencia: "Did you receive assistance (meals, accommodation)?",

    bloco3: "Block 3: Weather Conditions",
    clima: "Did weather conditions affect the airport?",
    anac: "Check weather conditions on the ANAC website:",
    cliqueAqui: "Click here",

    bloco4: "Block 4: Baggage",
    bagagem: "Did you have any problems with your baggage?",
    nenhum: "There were no problems with my baggage",
    extravio: "Lost",
    dano: "Damaged",
    furto: "Stolen",

    verificar: "Check Responsibility",
    proximaPagina: "Go to next page",

    // Results
    resultadoNaoIndicios: "There is no evidence of direct airline liability.",
    excludente: "⚠️ There are elements indicating ground(s) for exclusion of airline liability.",
    excludenteEResponsavel: "⚠️ There are elements indicating ground(s) for exclusion of airline liability, but there are also indications of liability.",
    podeResponsabilizar: "✅ The airline may be held liable according to the reported facts.",
    passageiroAntecedencia: "Passenger did not arrive within the minimum required advance time. The airline may not be held liable.",
    conexaoExcludente: "Exclusionary ground: separately purchased connection. Responsibility lies with the consumer.",
    atraso: "Flight delayed by more than 4 hours. The airline should have provided assistance.",
    atrasoSemAssistencia: "The airline may be held liable for failure to provide assistance during the delay.",
    climaExcludente: "Exclusionary ground: adverse weather conditions may exempt the airline from liability.",
    bagagemExtravio: "Reported baggage issue: loss/misplacement.",
    bagagemDano: "Reported baggage issue: damage.",
    bagagemFurto: "Reported baggage issue: theft.",
    bagagemFurtoExcludente: "Exclusionary ground: valuable items must be carried in hand luggage and declared.",
  },
};